import { type Translationtype } from "utils";

interface ISubmitButtonProps {
  showLoader: boolean;
  disabled?: boolean;
  text?: string;
  className?: string;
  submitName?: string;
  extraClassName?: string;
  t: Translationtype;
}
export function SubmitButton({
  showLoader,
  disabled,
  text,
  className,
  submitName,
  extraClassName,
  t,
}: ISubmitButtonProps) {
  return (
    <button
      name={submitName ? submitName : undefined}
      className={`btn ${className || ""} ${
        disabled || showLoader
          ? "btn-disabled"
          : extraClassName || "btn-primary"
      }`}
      disabled={disabled || showLoader}
      type="submit"
    >
      <div className="flex flex-row items-center justify-center gap-5">
        {showLoader ? <span className="loading loading-spinner" /> : null}
        {t(text || ("Buttons.next" as any))}
      </div>
    </button>
  );
}
